import { useQuery } from '@tanstack/react-query';

import { getTeamToday } from '../apis';
import { teamKeys } from './teamKeys';

export const useTeamToday = () =>
  useQuery({
    queryKey: teamKeys.today,
    queryFn: getTeamToday,
  });
